import PropTypes from "prop-types";
import { Box, Typography } from "@mui/material";

import { Button } from "../components/Button.jsx";
import { UnifiedModal } from "../components/UnifiedModal.jsx";

export function TutorialCompletionModal({
  open,
  onClose,
  title = "Tutorial completado",
  description,
  buttonLabel = "Cerrar",
  onPrimaryAction,
  secondaryButtonLabel = null,
  onSecondaryAction,
  note,
  maxWidth = "xs",
}) {
  return (
    <UnifiedModal open={open} onClose={onClose} title={title} maxWidth={maxWidth}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          gap: 2,
          py: 1,
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            px: 1.5,
            py: 0.875,
            borderRadius: "999px",
            backgroundColor: (theme) => theme.palette.action.hover,
          }}
        >
          <Typography component="span" aria-hidden="true" sx={{ fontSize: "1rem", lineHeight: 1 }}>
            ✅
          </Typography>
          <Typography variant="body2" sx={{ fontWeight: 700, lineHeight: 1.2 }}>
            Tutorial terminado
          </Typography>
          <Typography component="span" aria-hidden="true" sx={{ fontSize: "1rem", lineHeight: 1 }}>
            🎊
          </Typography>
        </Box>

        <Typography variant="body1" sx={{ width: "100%", textAlign: "left", lineHeight: 1.7 }}>
          {description}
        </Typography>
        {note ? (
          <Typography
            variant="body2"
            sx={{ width: "100%", textAlign: "left", color: "text.secondary", lineHeight: 1.7 }}
          >
            {note}
          </Typography>
        ) : null}
        <Box
          sx={{
            width: "100%",
            display: "flex",
            gap: 1.5,
            flexWrap: "wrap",
            justifyContent: "flex-end",
          }}
        >
          {secondaryButtonLabel ? (
            <Button variant="outline" onClick={onSecondaryAction || (() => onClose?.(false))}>
              {secondaryButtonLabel}
            </Button>
          ) : null}
          <Button onClick={onPrimaryAction || (() => onClose?.(false))}>{buttonLabel}</Button>
        </Box>
      </Box>
    </UnifiedModal>
  );
}

TutorialCompletionModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string,
  description: PropTypes.string.isRequired,
  buttonLabel: PropTypes.string,
  onPrimaryAction: PropTypes.func,
  secondaryButtonLabel: PropTypes.string,
  onSecondaryAction: PropTypes.func,
  note: PropTypes.string,
  maxWidth: PropTypes.string,
};
